import {Box} from '@mui/material';
import moment from 'moment';
import {CellProps} from '..';

export const TimeCell = ({value}: CellProps) => {
  return (
    <Box className={`care-table-row-cell care-table-row-cell-hour`}>
      <p>{moment(value).format('DD/MM/YYYY HH:mm')}</p>
    </Box>
  );
};
